// extracted by mini-css-extract-plugin
module.exports = {"card":"card-module--card--1N9oe","cardHeader":"card-module--card-header--18oTz","link":"card-module--link--2pvy9","cardBody":"card-module--card-body--2qnrj"};